import { captureException } from '@sentry/react'
import { state$ } from '@core/State/UserAccount/userAccountDriver'

export function logError(
  err: Error | string,
  logToSentry?: boolean,
  additionalProperties?: Record<string, unknown>
): void {
  if (console) {
    // eslint-disable-next-line no-console
    console.error(err)
  }

  if (logToSentry) {
    state$.take(1).subscribe(state => {
      captureException(err, scope => {
        if (additionalProperties) {
          scope.setExtras(additionalProperties)
        }
        if (state.accountNumber && state.isLoggedIn) {
          scope.setUser({
            id: state.accountNumber.toString(),
          })
        }
        return scope
      })
    })
  }
}
